import * as React from 'react';
import {Select} from '@sail/ui';

export const Uncontrolled = () => (
  <Select
    name="demo-001"
    onChange={(e) => {
      /* eslint-disable no-console */
      console.log(e);
    }}
    label="Choose a pet"
  >
    <option value="">Choose an option</option>
    <option value="dogs">Dogs</option>
    <option value="cats">Cats</option>
  </Select>
);
